import styled from 'styled-components';

export const TableContainer = styled.div`
  background: ${({ theme }) => theme.colors.gray8};
  padding: 1rem 1.5rem;
`;

export const TableCell = styled.div<{ width?: number }>`
  ${({ width }) => width && `max-width: ${width}px`}
`;

export const TableHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const TableHeaderItems = styled.div`
  display: flex;
  align-items: center;
  margin-top: auto;
  height: 3.5rem;
  border: #fff;
`;

export const TableHeaderInputContainer = styled.div`
  display: flex;
  flex: 1;
  height: 3.5rem;
`;

export const TableOrderNumberSelectable = styled.span`
  color: ${({ theme }) => theme.colors.blue6};
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
`;

export const WithoutDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  justify-content: center;
  align-items: center;

  height: 72vh;

  gap: 1.5rem;

  > img {
    width: 7.5rem;
  }
`;

export const WithoutDataTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const WithoutDataText = styled.span`
  color: ${({ theme }) => theme.colors.grayDark4};

  font-size: 1.25rem;
  font-weight: 400;
  line-height: 28px;

  text-align: center;
`;

export const MessageWithoutEmitter = styled.h4`
  color: #495961;
  font-size: 24px;
  line-height: 32px;
  font-family: 'Source Sans Pro';
  font-weight: 600;
  text-align: center;
  width: 31rem;
`;
